export default __webpack_public_path__ + "static/erdinger_radler_2-0b456ada38d30d38562117755d645b68.png";